module.exports = __webpack_public_path__ + "img/people.cda47d1b.png";